import React from "react";
import {useEffect} from "react";
import {useRef} from "react";
import {skills} from "../../database/skills";

const SkillsCards: React.FC = () => {
  const frontSkillsRef = useRef<HTMLDivElement>(null);

  const handleScroll = (): void => {
    const frontSkillsElement: HTMLDivElement =
      frontSkillsRef.current as HTMLDivElement;

    if (
      frontSkillsElement &&
      frontSkillsElement.getBoundingClientRect().top < window.innerHeight
    ) {
      frontSkillsElement.className =
        "max-[565px]:flex max-[565px]:flex-col opacity-100 duration-[0.7s] ease-in-out";
    }
  };

  useEffect((): (() => void) => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      ref={frontSkillsRef}
      className=" translate-y-2 opacity-0 max-[565px]:flex max-[565px]:flex-col"
    >
      <div className="w-full grid grid-cols-5 max-[1140px]:grid-cols-4 max-[940px]:grid-cols-3 max-[700px]:grid-cols-2 max-[515px]:grid-cols-1 gap-4 p-4 rounded max-[975px]:p-5 max-[975px]:items-center">
        {skills.length &&
          skills.map(skill => (
            <div
              key={skill.name}
              className="flex items-center max-[255px]:justify-center w-44 gap-2 text-lg bg-neutral-900 p-4 mt-2 mb-2 rounded-skill-card max-[565px]:w-full "
            >
              <img
                src={skill.imgSrc}
                alt={`${skill.name}-icon`}
                className="-ml-1 h-[40px]"
              />
              <h6 className="max-[255px]:hidden">{skill.name}</h6>
            </div>
          ))}
      </div>

      {/* <div className=" flex gap-10  p-4 rounded max-[975px]:p-5 max-[975px]:flex-col max-[975px]:items-center">
        <div>
          {frontSkills.length &&
            frontSkills.map(skill => (
              <div
                key={skill.name}
                className="flex items-center max-sm:w- w-44 gap-2 text-lg bg-neutral-900 p-4 mt-2 mb-2 rounded-skill-card max-[565px]:w-full max-[565px]:gap-2"
              >
                <img
                  src={skill.imgSrc}
                  alt={`${skill.name}-icon`}
                  style={{height: "40px"}}
                  className="-ml-1"
                />
                {skill.name}
              </div>
            ))}
        </div>

        <div className="max-[975px]:-mt-12">
          {backSkills.length &&
            backSkills.map(skill => (
              <div
                key={skill.name}
                className="flex items-center w-44 gap-2 text-lg bg-neutral-900 p-4 mt-2 mb-2 rounded-r-skill-card max-[565px]:gap-2 max-[565px]:w-full max-[500px]:flex max-[500px]:justify-start max-[500px]:text-2xl"
              >
                <img
                  src={skill.imgSrc}
                  alt={`${skill.name}-icon`}
                  style={{height: "40px"}}
                />
                {skill.name}
              </div>
            ))}
        </div>
        <div className="max-[975px]:-mt-12">
          {databaseSkills.length &&
            databaseSkills.map(skill => (
              <div
                key={skill.name}
                className="flex items-center w-44 gap-2 text-lg bg-neutral-900 p-4 mt-2 mb-2 rounded-r-skill-card max-[565px]:gap-2 max-[565px]:w-full max-[500px]:flex max-[500px]:justify-start "
              >
                <img
                  src={skill.imgSrc}
                  alt={`${skill.name}-icon`}
                  style={{height: "40px"}}
                />
                {skill.name}
              </div>
            ))}
        </div>

        <div className="max-[975px]:-mt-12">
          {othersSkills.length &&
            othersSkills.map(skill => (
              <div
                key={skill.name}
                className="flex items-center w-44 gap-2 text-lg bg-neutral-900 p-4 mt-2 mb-2 rounded-r-skill-card max-[565px]:w-40 max-[565px]:gap-2 max-[500px]:w-full max-[500px]:flex max-[500px]:justify-start "
              >
                <img
                  src={skill.imgSrc}
                  alt={`${skill.name}-icon`}
                  style={{height: "40px"}}
                />
                {skill.name}
              </div>
            ))}
        </div>
      </div> */}
    </div>
  );
};

export default SkillsCards;
